import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import store, { history } from "./store";
import setAuthorizationToken from "./modules/utils/setAuthorizationToken";
import { setCurrentUser } from "./modules/actions/authActions";
import App from "./App";
//import registerServiceWorker from "./registerServiceWorker";
import { unregister } from './registerServiceWorker';
import "./css/style.css";

if (localStorage.jwtToken) {
    const data = JSON.parse(localStorage.jwtToken);
    store.dispatch(setCurrentUser(data));
    console.log("index.js", data);
    setAuthorizationToken(data.token);
}

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <App />
            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
);
//registerServiceWorker();
unregister();


// WEBPACK FOOTER //
// ./src/index.js